import React, { useState, useRef } from 'react';
import './styles.css';
import ClubStandards from '../../containers/ClubStandards';
import EvaluationCommentBoxWrapper from '../../containers/EvaluationCommentBoxWrapper';
import OnSiteCommentBoxWrapper from '../../containers/OnSiteCommentBoxWrapper';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LicenceCommentBoxWrapper from '../../containers/LicenceCommentBoxWrapper';

const ResizableComponent = () => {
    const [dragging, setDragging] = useState(false);
    const [topHeight, setTopHeight] = useState('auto'); // Default height to fit content
    const containerRef:any = useRef(null);
    const initialMouseY = useRef(0);
    const initialTopHeight = useRef(0);
    const currentSection = useSelector((state:any) => state.evaluation.currentEvaluationTab);
    const drawer = useSelector((state:any) => state.common.drawer);
    const [t] = useTranslation();

    const handleMouseDown = (e:any) => {
      setDragging(true);
      document.body.style.cursor = 'row-resize';
      initialMouseY.current = e.clientY;
      initialTopHeight.current = containerRef.current
        .querySelector('.top')
        .getBoundingClientRect().height;
    };

    const handleMouseUp = () => {
      setDragging(false);
      document.body.style.cursor = '';
    };


    const handleMouseMove = (e:any) => {
        if (dragging && containerRef.current) {
        const containerHeight = containerRef.current.offsetHeight;
        const deltaY = e.clientY - initialMouseY.current;
        const newTopHeight = initialTopHeight.current + deltaY;
        const clampedTopHeight:any = Math.min(Math.max(newTopHeight, 0), containerHeight)/0.8;

        setTopHeight(clampedTopHeight);
        }
    };

    const dragIconRef = useRef(null);

    const handleDragStart = (event:any) => {
      if (dragIconRef.current) {
        // Set the custom drag image with offsets
        event.dataTransfer.setDragImage(dragIconRef.current, 10, 10);
      }
    };

  return (
    <div
      className="resizable-container"
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div className="top" style={{ height: topHeight }}>
        <ClubStandards />
      </div>
      <img
        ref={dragIconRef}
        src="../../assets/icons/resize-height.svg"
        alt="drag icon"
        style={{ display: 'none' }}
      />
      <div
        className="separator"
        onMouseDown={handleMouseDown}
        onDragStart={handleDragStart}
      />
      <div className="bottom">
        {drawer == 'Licence' && <LicenceCommentBoxWrapper />}
        {drawer == 'Evaluation' && currentSection == t('EVALUATION') && <EvaluationCommentBoxWrapper />}
        {drawer == 'Evaluation' && currentSection == t('ON_SITE') && <OnSiteCommentBoxWrapper />}
      </div>
    </div>
  );
};

export default ResizableComponent;
